
import stringMixin from './stringMixin';
import { crmBusinessStatusListAPI } from '@/api/crm/business';

export default {
  name: 'XhBusinessStatus', // 商机状态
  components: {},
  mixins: [stringMixin],
  props: {
    options: Array
  },
  data: function data() {
    return {
      // options: []
    };
  },

  computed: {},
  watch: {},
  mounted: function mounted() {
    // this.getBusinessStatusList()
  },

  methods: {
    /** 获取商机状态组 */
    getBusinessStatusList: function getBusinessStatusList() {
      var _this = this;

      crmBusinessStatusListAPI({}).then(function (res) {
        var list = res.data || [];
        _this.options = list.filter(function (item) {
          return item.status === 1;
        });
        if (_this.dataValue) {
          var hasValueItem = _this.options.find(function (item) {
            return item.type_id == _this.dataValue;
          });
          if (!hasValueItem) {
            _this.dataValue = '';
          }
          _this.$emit('value-change', {
            index: _this.index,
            value: _this.dataValue,
            data: _this.options,
            type: 'init' // 初始化下不更改阶段值
          });
        }
      }).catch(function () {});
    },

    // 输入的值
    valueChange: function valueChange(val) {
      /** 商机组顺便回调筛选数据 */
      this.$emit('value-change', {
        index: this.index,
        value: val,
        data: this.options
      });
    }
  }
};